import { UpsellEntryPointType } from '../types';
import type { ClickstreamPayload } from '@zg-rentals/clickstream';

export type TrackClickstreamEventFn = <T extends Record<string, unknown>>(args: ClickstreamPayload<T>) => void;

const getEnvelope = (eventTemplateId: string, eventTypeId: string) => ({
  event_template_id: eventTemplateId,
  event_template_version_id: '1',
  event_type_id: eventTypeId,
  event_type_version_id: '1',
});

export const CLICK_LEASE_SURVEY_SUBMIT = (reason: string, order: number) => {
  return {
    envelope: getEnvelope('171', '3831'),
    clickstream_trigger: {
      trigger_location_nm: 'leases|ri_upsell|survey',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: `submit_answer|${reason}|${order}`,
      input_selector_nm: '',
      trigger_reference_url: '',
      referral_url: '',
    },
    semantic: {
      semantic_event_nm: 'notrightnow_ri_survey',
      topic_tag_txt: ['renters_insurance'],
    },
    ri_entrypoints_info: { funnel_starting_point_cd: UpsellEntryPointType.LEASES_COMPLETED_SIGNING },
  };
};

export const CLICK_LEASE_UPSELL = (entryPoint: UpsellEntryPointType) => ({
  envelope: getEnvelope('171', '3680'),
  clickstream_trigger: {
    trigger_location_nm: 'leases|ri_upsell',
    trigger_type_nm: 'interaction',
    trigger_object_nm: 'no_trigger_object',
    trigger_source_nm: 'navigate_to_homesite',
    input_selector_nm: '',
    trigger_reference_url: '',
    referral_url: '',
  },
  semantic: {
    semantic_event_nm: 'start_ri_flow',
    topic_tag_txt: ['renters_insurance'],
  },
  ri_entry_points_info: { funnel_starting_point_cd: entryPoint },
});

export const CLICK_YOUR_RENTAL_APPLICATIONS_UPSELL = {
  envelope: getEnvelope('272', '5003'),
  clickstream_trigger: {
    trigger_location_nm: 'your_rental_applications|ri_upsell',
    trigger_type_nm: 'interaction',
    trigger_object_nm: 'no_trigger_object',
    trigger_source_nm: 'navigate_to_homesite',
  },
  semantic: {
    semantic_event_nm: 'start_ri_flow',
    topic_tag_txt: ['renters_insurance'],
  },
};

export const VIEW_LEASE_UPSELL = (entryPoint: UpsellEntryPointType) => ({
  envelope: getEnvelope('171', '3679'),
  clickstream_trigger: {
    trigger_location_nm: 'leases|ri_upsell',
    trigger_type_nm: 'impression',
    trigger_object_nm: 'no_trigger_object',
    trigger_source_nm: 'leases|ri_upsell',
    input_selector_nm: '',
    trigger_reference_url: '',
    referral_url: '',
  },
  semantic: {
    semantic_event_nm: 'view_content',
    topic_tag_txt: ['renters_insurance'],
  },
  ri_entry_points_info: { funnel_starting_point_cd: entryPoint },
});

export const VIEW_YOUR_RENTAL_APPLICATIONS_UPSELL = {
  envelope: getEnvelope('272', '5002'),
  clickstream_trigger: {
    trigger_location_nm: 'your_rental_applications|ri_upsell',
    trigger_type_nm: 'impression',
    trigger_object_nm: 'no_trigger_object',
    trigger_source_nm: 'your_rental_applications|ri_upsell',
  },
  semantic: {
    semantic_event_nm: 'view_content',
    topic_tag_txt: ['renters_insurance'],
  },
};
